import { ClassComponentRegistry } from '../utils/ClassComponentRegistry';
import { createUniversalProviders } from './UniversalClassProvider';

// Keep BrawlerProvider for reference (has special combat components)
import { BrawlerProvider } from './BrawlerProvider';

/**
 * Initialize and register all class providers using the new standardized system
 * This should be called once during app initialization
 */
export const initializeClassProviders = (): void => {
  // Clear existing providers (useful for testing)
  ClassComponentRegistry.clear();

  // Register universal providers for most classes
  const universalProviders = createUniversalProviders();
  universalProviders.forEach(provider => {
    // Skip brawler - it has a special provider with additional components
    if (provider.className !== 'brawler') {
      ClassComponentRegistry.register(provider);
    }
  });

  // Register special Brawler provider with additional combat components
  ClassComponentRegistry.register(new BrawlerProvider());
};

// Export providers for direct access if needed
export { BrawlerProvider };
export { BaseClassProvider } from './BaseClassProvider';
export { UniversalClassProvider } from './UniversalClassProvider';